export const buildInitialState = () => ({
  calculadoraPgbl: {
    loading: false,
    lastUpdate: null,
    data: [],
    result: {},
    tableData: [],
    headers: [],
    dataDetails: {},
    resultData: {},
    loadingSave: false,
    loadingSimulation: false,
    clients: [],
    clientsLoading: false,
    clientsNameMap: {},
    irConfig: null,
    irAnosDisponiveis: [],
    irAnoSelecionado: null,
  },
  transactions: {
    loading: false,
    lastUpdate: null,
    data: [],
    clientId: null,
  },
  budgets: {
    loading: false,
    lastUpdate: null,
    data: [],
    clientId: null,
  },
  goals: {
    loading: false,
    lastUpdate: null,
    data: [],
    clientId: null,
    totals: null,
    remaining: null,
    raw: null,
  },
  patrimony: {
    loading: false,
    lastUpdate: null,
    data: [],
    clientId: null,
  },
  patrimonyGoalLinks: {
    loading: false,
    lastUpdate: null,
    data: [],
    clientId: null,
  },
  assetGoalLinks: {
    loading: false,
    lastUpdate: null,
    data: [],
    clientId: null,
  },
  categories: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  subcategories: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  rules: {
    loading: false,
    lastUpdate: null,
    data: [],
    clientId: null,
  },
  investmentAccounts: {
    loading: false,
    lastUpdate: null,
    data: [],
    clientId: null,
  },
  investmentPortfolio: {
    loading: false,
    lastUpdate: null,
    data: {},
    clientId: null,
  },
  openFinanceConnectors: {
    loading: false,
    lastUpdate: null,
    data: [],
    meta: null,
  },
  openFinanceClientConnectors: {
    loading: false,
    lastUpdate: null,
    data: [],
    clientId: null,
  },

  receitasOuDespesas: {
    loading: false,
    lastUpdate: null,
    data: [],
    clientId: null,
  },
  simulacoes: {
    loading: false,
    lastUpdate: null,
    data: [],
    clientId: null,
  },
  // Filtro persistido de Transações/Orçamentos (período + categoria/subcategoria/
  // tipo/nomeRecorrente/estabelecimento/banco + `nome`, a busca textual livre).
  // Sobrevive à troca de aba (memória entre navegações).
  //
  // DOIS escritores, de propósito: o widget FpOrcamentosFilters escreve tudo o
  // que é campo do MENU; a busca livre (`nome`) é escrita pela toolbar da tabela
  // (`setNomeFilter` no view-orcamentos-mixin), porque o design-system exige que
  // busca escopada à tabela viva no `BaseTable showSearch`.
  filterOrcamentos: {},
  preferences: {
    relatoriosInterestRegistered:
      typeof globalThis !== 'undefined' &&
      globalThis.localStorage &&
      globalThis.localStorage.getItem('fp_relatorios_interesse_registrado') ===
        'true',
  },
  // Editor visual de relatório (Fase B.0.3 do PLANNING-INSIGHTS):
  // - secoes_ativas: mapa { key_da_secao: bool } controlando quais
  //   páginas vão para o PDF.
  // - comentario_consultor: texto opcional editado pelo consultor que
  //   aparece na página da Carta do Consultor (default '' para usar
  //   o texto-base hardcoded do template).
  // - comentario_encerramento: texto opcional editado pelo consultor
  //   que aparece na página de Encerramento (default '' para usar
  //   o texto-base hardcoded do template).
  // Por cliente — chave do mapa = id_cliente_app (compartilha entre
  // sessões via this.config[id]).
  relatorioConfig: {
    // porCliente: mapa indexado por id_cliente_app, cujo valor tem
    // secoes_ativas, comentario_consultor e comentario_encerramento.
    porCliente: {},
  },
  // Defaults office-level (Decisão 2+3 do CU-86agexp0v) — fallback usado
  // quando o cliente não tem override no slice acima. Persistidos no
  // backend em `financial_planning_relatorio_config_escritorio` e
  // configurados em /configuracoes/financial-planning/modelo-relatorio.
  relatorioConfigEscritorio: {
    loading: false,
    loaded: false,
    secoes_ativas: {},
    comentario_consultor: '',
    comentario_encerramento: '',
  },
  // {{NEXT}}
})

export default buildInitialState()
